/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-09-09                                                        *
 ******************************************************************************/

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../images/dynabook_black.jpg'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from '../apps/dynabook_public/app.vue'
import VueCompositionAPI from "@vue/composition-api";

Vue.use(BootstrapVue);
Vue.use(VueCompositionAPI);

document.addEventListener('DOMContentLoaded', () => {
    const el = document.body.appendChild(document.createElement('div'))
    const app = new Vue({
        el,
        render: h => h(App)
    });
});
